import Body from 'iovisit-ferraraterraeacqua/components/Blocks/Prenotazioni/Components/Body';

const View = (props) => {
  const { data } = props;

  return (
    <div className="block prenotazioni">
      <Body data={data} />
    </div>
  );
};

export default View;
